import layout from './Switch.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import SwitchViewModel from '@/Components/Switch/SwitchViewModel';
import CheckBox from '@/Controls/CheckBox';
import ImageType from '@/Controls/Image';

export default class Switch extends CheckBox {

    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private image: ImageType;

    public constructor(protected viewModel: SwitchViewModel, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'switch',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            locator: this.viewModel.locator,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),
            attr: {
                'data-value': this.viewModel.value,
                'data-checked': this.viewModel.isChecked
            },
            hotkey: {
                shortcut: 'space',
                handler: (e: ExtendedKeyboardEvent) => {
                    this.viewModel.toggleIfEnabled();
                    e.stopPropagation();
                    e.preventDefault();
                },
                isGlobal: false
            }
        });

        this.applyBindings(this.jQueryControl.find('input'), {
            checked: this.viewModel.isChecked,
            enable: this.viewModel.isEnabled,
            attr: {
                id: this.identifier
            }
        });

        this.applyBindings(this.jQueryControl.find('.slider-round'), {
            locator: this.viewModel.locator,
            focus: this.viewModel.isFocusable
        });

        this.addEventHandler('click', this.jQueryControl, () => {
            this.viewModel.toggleIfEnabled();
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label, $('<label for="' + this.identifier + '">').prependTo(this.jQueryControl));
            const tuple = this.label.getTuple();
        }

        if (this.viewModel.image != null) {
            this.image = new this.Image(this.viewModel.image);
            let tuple = this.image.getTuple();

            tuple.control.prependTo(this.jQueryControl);
        }

        if (this.viewModel.onClick != null) {
            this.addEventHandler('click', this.jQueryControl, (event: JQuery.Event) => {
                if (this.viewModel.isEnabled()) {
                    this.viewModel.onClick(this.viewModel.isChecked(), this.viewModel.value());
                }
            });
        }
    }
}

ComponentManager.setControl('Switch', Switch, 'RADPresentation.HTMLClient.DefaultViewExtensions');